import PropTypes from "prop-types";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ProtectedLayout({ children }) {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
  }, []);

  return (
    <main>
      {children}
    </main>
  );
}

ProtectedLayout.propTypes = {
  children: PropTypes.node
};
